import { analytics } from "../utils/firebaseConfig";

const amplitude = require("amplitude-js");
amplitude.getInstance().init(process.env.VUE_APP_AMPLITUDE_KEY);

export function logEvent(eventName, options) {
  if (options) {
    analytics.logEvent(eventName, options);
    amplitude.getInstance().logEvent(eventName, options);
  } else {
    analytics.logEvent(eventName);
    amplitude.getInstance().logEvent(eventName);
  }
}
